
import {
  defineComponent,
} from 'vue';
import ItemMixed from '@/modules/drive/components/items/ItemMixed.vue';
import AppHeader from '../AppHeader.vue';
import AppSearch from '../UI/AppSearch.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  props: {
    title: { type: String, default: '' },
    grid: { type: Boolean, required: true },
    hideSkeletons: { type: Boolean, default: false },
  },
  components: {
    ItemMixed,
    AppHeader,
    AppSearch,
  },
  setup() {
    const mainStore = useMainStore();
    return {
      mainStore,
    };
  },
});

